<template>
	<v-card>
		<v-card-title>New Part</v-card-title>
		<v-card-text>
			<v-form ref="form">
				<v-text-field v-model="name" label="Name"></v-text-field>
				<v-text-field v-model="description" label="Description"></v-text-field>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn @click="save" rounded dark color="primary2"> 
				Save
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "NewAssessmentPart", 
		props: {
			
		},
		data: () => {
			return {
				name: "", 
				description: "",
				sections: []
			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		methods: {
			save(){
				var part = {...this.$data}
				part.id = this.generateId();				
				this.$store.dispatch("assessmentSettings/newPart", part);
				this.$emit("close");
				this.$refs.form.reset();
			}
		}
		// created(){
			
		// }

	}
</script>